module.exports = "<p>report works!</p>\n"